import { Box, Grid, Hidden, Paper, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { PiBookmarksLight } from "react-icons/pi";
import CircularProgressRing from "../CircularProgressRing";
import { LOCALE } from "../../properties/Locale";
import { useTheme } from "@emotion/react";

const steps = [
  {
    number: 1,
    text: " Со пристапување во модулот за измена на режимот од времен или траен карактер се пристапува до соодветен формулар.",
  },
  {
    number: 2,
    text: "Како прилог потребно е да се прикачи комплетен сообраќаен план и урабнистички план во .pdf формат, како и во .dwg формат.",
  },
  {
    number: 3,
    text: "Прикачените документи како и сите пополнети податоци потребно е да се потпишат со помош на дигитален потпис.",
  },
];

export default function SystemInfoPanel() {
  const theme = useTheme();
  const [activeStep, setActiveStep] = useState(0);
  const [progress, setProgress] = useState(0);
  const intervalRef = useRef(null);
  const intervalSeconds = 5;
  const progressRef = useRef(null);

  useEffect(() => {
    startTimer();
    startProgress();
    return () => {
      stopTimer();
      stopProgress();
    };
  }, []);

  useEffect(() => {
    setProgress(0);
  }, [activeStep]);

  const startTimer = () => {
    if (intervalRef.current) return;
    intervalRef.current = setInterval(() => {
      setActiveStep((prev) => (prev + 1) % steps.length);
    }, intervalSeconds * 1000);
  };

  const stopTimer = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = null;
  };

  const startProgress = () => {
    if (progressRef.current) return;
    progressRef.current = setInterval(() => {
      setProgress((prev) => {
        const next = prev + 100 / (intervalSeconds * 10);
        return next >= 100 ? 0 : next;
      });
    }, 100);
  };

  const stopProgress = () => {
    clearInterval(progressRef.current);
    progressRef.current = null;
  };

  return (
    <Grid item xs={12} md={6}>
      <Paper
        elevation={2}
        sx={{
          padding: 2,
          pt: 2.5,
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            fontSize: { xs: "36px", md: "48px" },
          }}
        >
          <PiBookmarksLight color="#e59900" style={{ flexShrink: 0 }} />
          <Typography
            variant="h6"
            style={{
              fontFamily: "Inter-Medium",
              color: "#171718",
              lineHeight: "1.2",
            }}
          >
            {LOCALE.systemName}
          </Typography>
        </Box>
        {steps.map((step, index) => {
          const isActive = index === activeStep;
          return (
            <Box
              key={step.number}
              sx={{
                marginTop: "15px",
                display: "flex",
                padding: "20px",
                height: "45px",
                color: isActive ? "#f2f2f2" : theme.palette.secondary.main,
                background: isActive
                  ? "linear-gradient(135deg, rgb(4, 85, 152), rgb(0, 112, 204))"
                  : "transparent",
                transform: isActive ? "scale(1.02)" : "scale(1)",
                boxShadow: isActive
                  ? "rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;"
                  : "none",
                fontFamily: "Inter-Regular",
                lineHeight: "1.1",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: 2,
                transition:
                  "background-color 0.5s ease, transform 0.5s ease, box-shadow 0.5s ease",
              }}
            >
              <Box sx={{ position: "relative", width: "35px", height: "35px" }}>
                <CircularProgressRing progress={isActive ? progress : 0} />
                <Box
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "17px",
                    color: isActive ? "#fff" : "#c0c0c0",
                  }}
                >
                  {step.number}
                </Box>
              </Box>
              <Box sx={{ flex: 1 }}>
                <Hidden smDown>
                  <Typography variant="body1">{step.text}</Typography>
                </Hidden>
                <Hidden mdUp>
                  <Typography variant="body2">{step.text}</Typography>
                </Hidden>
              </Box>
            </Box>
          );
        })}
      </Paper>
    </Grid>
  );
}
